import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'

type BulkOperationFieldProps = {
  label: string
  required?: boolean
  /** ラベル右端に出す補助情報（選択件数など） */
  note?: string
}

export const BulkOperationField: React.FC<BulkOperationFieldProps> = ({ label, required = false, note, children }) => {
  const { t } = useTranslation()

  return (
    <div css={fieldStyle}>
      <div className="label">
        {label}
        {required && <span className="required">{t('*')}</span>}
        {note && <span className="note">{note}</span>}
      </div>
      {children}
    </div>
  )
}

type BulkOperationNoteProps = {
  items: string[]
  /** attention: 実行結果が戻せない類の注意。info: 仕様の補足 */
  tone?: 'attention' | 'info'
}

export const BulkOperationNote: React.FC<BulkOperationNoteProps> = ({ items, tone = 'attention' }) => (
  <ul css={[noteStyle, tone === 'info' && infoNoteStyle]}>
    {items.map(item => (
      <li key={item}>{item}</li>
    ))}
  </ul>
)

const fieldStyle = css({
  '.label': {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    letterSpacing: 0.6,
    color: '#676767',
    paddingBottom: 12,
  },
  // 他の入力フィールド（molecules/label）と同じ必須表記に合わせる
  '.required': {
    paddingLeft: 8,
    fontSize: 8,
    letterSpacing: 0.4,
  },
  '.note': {
    marginLeft: 'auto',
    fontWeight: 'normal',
    color: '#a3a3a3',
  },
})

const noteStyle = css({
  listStyle: 'none',
  padding: '11px 14px',
  borderRadius: 4,
  border: '1px solid #f0dcb6',
  backgroundColor: '#fdf8ee',
  li: {
    position: 'relative',
    paddingLeft: 12,
    fontSize: 12,
    lineHeight: 1.75,
    color: '#8a7442',
    '::before': {
      content: '"・"',
      position: 'absolute',
      left: -2,
    },
  },
})

const infoNoteStyle = css({
  border: '1px solid #e3e3e3',
  backgroundColor: '#f7f8fa',
  li: { color: '#676767' },
})
